import { combineReducers } from 'redux'
import {
  createReducer,
  createMappedRequestReducer
} from 'pobble-components/dist/redux-helpers'
import { normalize, schema } from 'normalizr'

const normalizePermissionSlips = data => {
  const pemrission = new schema.Entity('permissions')
  return normalize(data, [pemrission])
}

const PermissionsReducer = combineReducers({
  uploadingPermission: createMappedRequestReducer(
    'PERMISSIONS_STORE:UPLOAD_PERMISSION'
  ),
  deletingPermission: createMappedRequestReducer(
    'PERMISSIONS_STORE:DELETE_PERMISSION'
  ),
  permissions: createReducer(null, {
    'PERMISSIONS_STORE:FETCHING_REQUEST_SUCCESS': (
      state,
      { params, response }
    ) => normalizePermissionSlips(response.data.permission_slips),
    'PERMISSIONS_STORE:DELETE_PERMISSION_REQUEST_SUCCESS': (
      state,
      { params, response }
    ) => {
      const permissions = { ...state.entities.permissions }
      delete permissions[params.id]
      return {
        entities: { permissions },
        result: state.result.filter(id => id !== params.id)
      }
    },
    'PERMISSIONS_STORE:UPLOAD_PERMISSION_REQUEST': (
      state,
      { params, response }
    ) => ({
      ...state,
      entities: {
        permissions: {
          ...state.entities.permissions,
          [params.id]: { file_name: params.file.name }
        }
      },
      result: [...state.result, params.id]
    }),
    'PERMISSIONS_STORE:UPLOAD_PERMISSION_REQUEST_SUCCESS': (
      state,
      { params, response }
    ) => {
      const permissions = { ...state.entities.permissions }
      delete permissions[params.id]
      permissions[response.data.permission_slip.id] =
        response.data.permission_slip
      return {
        entities: { permissions },
        result: state.result.map(
          id => (id === params.id ? response.data.permission_slip.id : id)
        )
      }
    }
  })
})

export default PermissionsReducer
